import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/design-system.css';

export default function TrendingTravelLocations() {
  const [trendingLocations, setTrendingLocations] = useState([]);
  const [unusualTrips, setUnusualTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading trending locations
    setTimeout(() => {
      setTrendingLocations([
        {
          id: 1,
          name: 'Bali, Indonesia',
          description: 'Tropical paradise with rich culture and stunning beaches',
          image: '/sebastian-pena-lambarri-7i5HMCGupVw-unsplash.jpg',
          popularity: 95,
          category: 'beach',
          price: '£800',
          duration: '7 days'
        },
        {
          id: 2,
          name: 'Reykjavik, Iceland',
          description: 'Northern lights, geothermal spas, and dramatic landscapes',
          image: '/sebastian-pena-lambarri-7i5HMCGupVw-unsplash.jpg',
          popularity: 88,
          category: 'adventure',
          price: '£1200',
          duration: '5 days'
        },
        {
          id: 3,
          name: 'Tokyo, Japan',
          description: 'Modern metropolis with ancient traditions and amazing food',
          image: '/sebastian-pena-lambarri-7i5HMCGupVw-unsplash.jpg',
          popularity: 92,
          category: 'city',
          price: '£1500',
          duration: '10 days'
        },
        {
          id: 4,
          name: 'Marrakech, Morocco',
          description: 'Exotic souks, stunning architecture, and desert adventures',
          image: '/sebastian-pena-lambarri-7i5HMCGupVw-unsplash.jpg',
          popularity: 85,
          category: 'cultural',
          price: '£600',
          duration: '6 days'
        }
      ]);

      setUnusualTrips([
        {
          id: 1,
          name: 'Weekend Trip: Hidden Villages of Tuscany',
          description: 'Discover authentic Italian villages away from tourist crowds',
          organizer: 'Sarah M.',
          date: '2024-03-15',
          price: '£350',
          participants: 8,
          maxParticipants: 12,
          category: 'weekend'
        },
        {
          id: 2,
          name: 'Offbeat Adventure: Mongolian Nomad Experience',
          description: 'Live with nomadic families in the Mongolian steppe',
          organizer: 'Mike R.',
          date: '2024-04-20',
          price: '£1200',
          participants: 4,
          maxParticipants: 6,
          category: 'adventure'
        },
        {
          id: 3,
          name: 'Weekend Trip: Secret Beaches of Croatia',
          description: 'Explore hidden coves and crystal-clear waters',
          organizer: 'Emma L.',
          date: '2024-05-10',
          price: '£450',
          participants: 6,
          maxParticipants: 10,
          category: 'weekend'
        },
        {
          id: 4,
          name: 'Cultural Immersion: Traditional Japanese Tea Ceremony',
          description: 'Learn the art of tea ceremony in a traditional ryokan',
          organizer: 'David K.',
          date: '2024-06-05',
          price: '£800',
          participants: 3,
          maxParticipants: 5,
          category: 'cultural'
        }
      ]);

      setLoading(false);
    }, 1000);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Loading trending destinations...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="trending-travel-locations">
      {/* Trending Destinations */}
      <div className="card p-6 mb-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center">
            <span className="text-white text-lg">🌍</span>
          </div>
          <div>
            <h3 className="text-xl font-semibold">Trending Travel Locations</h3>
            <p className="text-gray-600">Discover the most popular destinations this season</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {trendingLocations.map((location) => (
            <div key={location.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
              <div className="relative">
                <img 
                  src={location.image} 
                  alt={location.name}
                  className="w-full h-48 object-cover"
                />
                <div className="absolute top-2 right-2 bg-white/90 rounded-full px-2 py-1 text-xs font-semibold">
                  {location.popularity}% Popular
                </div>
              </div>
              <div className="p-4">
                <h4 className="font-semibold text-lg mb-2">{location.name}</h4>
                <p className="text-gray-600 text-sm mb-3">{location.description}</p>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-primary font-semibold">{location.price}</span>
                  <span className="text-gray-500">{location.duration}</span>
                </div>
                <button className="w-full mt-3 btn btn-primary btn-sm">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Unusual & Offbeat Trips */}
      <div className="card p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center">
            <span className="text-white text-lg">🌟</span>
          </div>
          <div>
            <h3 className="text-xl font-semibold">Unusual & Offbeat Holidays</h3>
            <p className="text-gray-600">Unique travel experiences organized by our community members</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {unusualTrips.map((trip) => (
            <div key={trip.id} className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-6 border border-purple-200">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h4 className="font-semibold text-lg mb-2">{trip.name}</h4>
                  <p className="text-gray-700 text-sm mb-3">{trip.description}</p>
                </div>
                <span className={`text-xs px-2 py-1 rounded ${
                  trip.category === 'weekend' ? 'bg-blue-200 text-blue-800' :
                  trip.category === 'adventure' ? 'bg-green-200 text-green-800' :
                  'bg-purple-200 text-purple-800'
                }`}>
                  {trip.category.toUpperCase()}
                </span>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
                <div>
                  <span className="text-gray-600">Organizer:</span>
                  <p className="font-medium">{trip.organizer}</p>
                </div>
                <div>
                  <span className="text-gray-600">Date:</span>
                  <p className="font-medium">{new Date(trip.date).toLocaleDateString()}</p>
                </div>
                <div>
                  <span className="text-gray-600">Price:</span>
                  <p className="font-medium text-primary">{trip.price}</p>
                </div>
                <div>
                  <span className="text-gray-600">Spots:</span>
                  <p className="font-medium">{trip.participants}/{trip.maxParticipants}</p>
                </div>
              </div>

              <div className="flex gap-2">
                <button className="btn btn-primary btn-sm flex-1">
                  Join Trip
                </button>
                <button className="btn btn-secondary btn-sm">
                  Contact Organizer
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <h4 className="font-semibold text-blue-900 mb-2">About Our Community Trips:</h4>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>• All trips are organized by verified community members</li>
            <li>• Unique experiences you won't find elsewhere</li>
            <li>• Small group sizes for authentic experiences</li>
            <li>• Safety guidelines and community reviews</li>
            <li>• Direct contact with trip organizers</li>
          </ul>
        </div>
      </div>
    </div>
  );
} 